// extracted by mini-css-extract-plugin
export var colorSquare = "_nb-0";
export var container = "_nb-h";
export var danger = "_nb-5";
export var lightPink = "_nb-8";
export var neutralBlue = "_nb-7";
export var neutralYellow = "_nb-6";
export var normal = "_nb-1";
export var primary = "_nb-2";
export var primaryLight = "_nb-3";
export var selected = "_nb-i";
export var solidBlack = "_nb-g";
export var solidGreen = "_nb-b";
export var solidLightBlue = "_nb-d";
export var solidNavy = "_nb-c";
export var solidOrange = "_nb-f";
export var solidPink = "_nb-e";
export var solidRed = "_nb-9";
export var solidYellow = "_nb-a";
export var success = "_nb-4";